import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Cursor arrow pointer */}
      <path
        d="M4 4l7 17 2.5-6.5L20 12 4 4z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      {/* Selection marquee (dashed rectangle) */}
      <rect
        x="14"
        y="14"
        width="7"
        height="7"
        stroke={color}
        strokeWidth={strokeWidth * 0.75}
        strokeDasharray="2 1"
        fill="none"
        rx="1"
      />
    </BaseIcon>
  ),
);

SelectModeIcon.displayName = 'SelectModeIcon';
